<template lang="pug">
.profile-page-skeleton
  .skeleton-header
    .skeleton-avatar
    .skeleton-name
  
  .skeleton-content
    .skeleton-tabs
      .skeleton-tab(v-for="n in 2" :key="n")
    
    .skeleton-sections
      .skeleton-section(v-for="n in 3" :key="n")
        .skeleton-section-title
        .skeleton-section-content
          .skeleton-line(v-for="i in 3" :key="i")
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProfilePageSkeleton',
});
</script>

<style lang="scss" scoped>
.profile-page-skeleton {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.skeleton-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  background: linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%);
  
  @media (min-width: 768px) {
    padding: 64px 40px;
  }
  
  @media (min-width: 1024px) {
    padding: 80px 64px;
  }
}

.skeleton-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(90deg, #ECECEC 25%, #E0E0E0 50%, #ECECEC 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    width: 150px;
    height: 150px;
  }
}

.skeleton-name {
  width: 250px;
  height: 32px;
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  
  @media (min-width: 768px) {
    width: 300px;
    height: 40px;
  }
}

.skeleton-content {
  padding: 32px 24px 64px;
  
  @media (min-width: 768px) {
    padding: 40px 40px 80px;
  }
  
  @media (min-width: 1024px) {
    padding: 48px 64px 96px;
  }
}

.skeleton-tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  justify-content: center;
  
  @media (min-width: 768px) {
    gap: 24px;
    margin-bottom: 40px;
  }
}

.skeleton-tab {
  width: 100px;
  height: 40px;
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  
  @media (min-width: 768px) {
    width: 120px;
    height: 48px;
  }
}

.skeleton-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
  
  @media (min-width: 768px) {
    gap: 40px;
  }
}

.skeleton-section {
  width: 100%;
}

.skeleton-section-title {
  width: 150px;
  height: 24px;
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin-bottom: 16px;
  
  @media (min-width: 768px) {
    width: 180px;
    height: 28px;
    margin-bottom: 20px;
  }
}

.skeleton-section-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeleton-line {
  height: 16px;
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  
  &:nth-child(1) {
    width: 100%;
  }
  
  &:nth-child(2) {
    width: 90%;
  }
  
  &:nth-child(3) {
    width: 75%;
  }
  
  @media (min-width: 768px) {
    height: 18px;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
